export default [
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'French' }
];



// WEBPACK FOOTER //
// ./src/conf/platformLanguages.js